import { Typography } from '@mui/material'
import { Trans, useTranslation } from 'react-i18next'

export const DescriptionCondtition = (): JSX.Element => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'supplyChain.domainSids',
  })

  return (
    <Trans
      components={{
        bold: (
          <Typography
            component='span'
            fontWeight='bold'
            variant='subtitle1'
          />
        ),
      }}
      i18nKey='description.condition'
      t={t}
    />
  )
}
